import { Box, BoxProps, Center, Icon, Image } from "@chakra-ui/react";
import { CraNode } from "../../../cra/models/CraNode";
import { NoImageIcon } from "../icons";
import { useState } from "react";

export const NodePhoto: React.FC<
  {
    node: CraNode;
  } & BoxProps
> = ({ node, ...boxProps }) => {
  const [imageBroken, setImageBroken] = useState(false);
  return (
    <Box overflow={"hidden"} {...boxProps}>
      {imageBroken ? (
        <Center bgColor={"bg.emphasized"} aspectRatio={16 / 9}>
          <Icon as={NoImageIcon} size="2xl" color={"fg.subtle"} />
        </Center>
      ) : (
        <Image
          src={node.photo?.url || ""}
          loading="lazy"
          onError={() => setImageBroken(true)}
        />
      )}
    </Box>
  );
};
